export default {
  inject: {
    $entityId: {
      default: null,
    },
    $parentForm: {
      default: null,
    },
    $getParentEditor: {
      default: null,
    },
  },
  props: {
    entity: {
      type: String,
    },
    entityField: {
      type: String,
    },
    entityId: {
      type: Number,
    },
    entityIdFromField: {
      type: String,
    },
  },
  methods: {
    getEntityId() {
      if (this.entityId) {
        return this.entityId;
      }
      if (this.entityIdFromField
        && this.$parentForm
        && this.$parentForm.draft
        && this.$parentForm.draft[this.entityIdFromField]) {
        return this.$parentForm.draft[this.entityIdFromField];
      }
      if (this.$getParentEditor) {
        return this.$getParentEditor().id;
      }
      return this.$entityId;
    },
  },
};
